import React from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button, Link } from 'formlabs-web-components/Link';

const MediaLink = ({
  linkDisplay,
  linkText,
  buttonColor,
  mediaFile,
  arrow
}) => {
  if (linkDisplay === 'text') {
    return <Link to={mediaFile}>{linkText}</Link>;
  }
  return (
    <Button to={mediaFile} color={buttonColor} arrow={arrow}>
      {linkText}
    </Button>
  );
};

export default DisplayComponent(MediaLink);
